const CALLER_SNACK_HANDOFF_WINDOW_MS = 2000;

let armedAt: number | null = null;

const armForNextErrorSnack = (now: number = Date.now()): void => {
	armedAt = now;
};

const claimNextErrorSnack = (now: number = Date.now()): boolean => {
	if (armedAt === null) return false;
	const withinHandoffWindow = now - armedAt <= CALLER_SNACK_HANDOFF_WINDOW_MS;
	armedAt = null;
	return withinHandoffWindow;
};

const trialLimitSnackGate = { armForNextErrorSnack, claimNextErrorSnack };

export default trialLimitSnackGate;
